import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Tooltip, Input} from "reactstrap";
import PropTypes from 'prop-types';
import LaddaButton, {ZOOM_OUT} from "react-ladda";
import { connect } from 'react-redux';
import {updateCompany} from './../../actions';

class NoteAction extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tooltip: false,
      modal: false,
      loading: false,
      adminNote: props.user.adminNote
    };

    this.updateNote = this.updateNote.bind(this);
  }

  toggle(property) {
    this.setState({[property]: !this.state[property]})
  }

  updateNote() {
    this.setState({loading: true});

    this.props.updateCompany({
      data:  {
        id: this.props.user.id,
        user: {
          adminNote: this.state.adminNote
        }
      },
    }).then(() => {
      this.props.handleChange();
      this.setState({
        loading: false,
        modal: false
      })
    })
  }

  render() {
    return (
      <React.Fragment>
        <span id={'adminNote-' + this.props.user.id} className={"fas fa-comment mr-2" + (this.props.user.adminNote ? " text-primary" : "")} onClick={() => this.toggle('modal')}/>
        <Tooltip
          delay={0}
          placement="bottom"
          isOpen={this.state.tooltip}
          target={'adminNote-' + this.props.user.id}
          toggle={() => this.toggle('tooltip')}
        >
          <FormattedMessage id="admin.companies.noteAction.tooltip" />
        </Tooltip>

        <Modal isOpen={this.state.modal} toggle={() => this.toggle('modal')}>
          <ModalHeader toggle={() => this.toggle('modal')} tag="h2"><FormattedMessage id="admin.companies.noteAction.modalHeader"/></ModalHeader>
          <hr className="my-0" />
          <ModalBody>
            <Input type="textarea" value={this.state.adminNote} rows={6} onChange={e => this.setState({adminNote: e.target.value})}/>
          </ModalBody>
          <ModalFooter>
            <div className="direction-group d-flex justify-content-end">
              <div className="direction-right">
                <FormattedMessage id="_.button.save">{
                  (message) => <LaddaButton
                    className="btn btn-primary btn-ladda mb-0 ml-3"
                    data-style={ZOOM_OUT}
                    onClick={this.updateNote}
                    loading={this.state.loading}
                  >
                    {message}
                  </LaddaButton>
                }</FormattedMessage>
                <FormattedMessage id="_.button.cancel">{
                  (message) => <Button color="secondary" className="mb-0 ml-3" onClick={() => this.toggle('modal')}>{message}</Button>
                }</FormattedMessage>
              </div>
            </div>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    )
  }
}

NoteAction.propTypes = {
  user: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default connect(null, {updateCompany})(NoteAction);